import { IVisitedItem, IVisitedInfo } from './interface';


/**
 * 返回最近访问记录数组
 * @param visitedList 
 * @param visitedItem 
 * @returns 
 */
function getVisitedList(visitedList: any[], visitedItem: IVisitedItem) {
    let visited = null;
    let list = visitedList.filter(item => { // 过滤出当前数组中存在的最近访问记录
        if (item.appId === visitedItem.appId) {
            visited = item;
            return false;
        }
        return true;
    });
    if (visited) { // 如果已经存在数组中，则直接返回
        // return visitedList;
        return [...list, visitedItem];
    }
    if (visitedList.length < 3) { // 长度小于3直接存放
        visitedList.push(visitedItem);
    } else { // 否则 先删除再添加
        visitedList.shift();
        visitedList.push(visitedItem);
    }
    return visitedList;
}

/**
 * 根据userkey 返回 剩余内容和提取出来的内容
 * @param userKey 用户cUserId
 * @param visitedItem 用户最近访问记录
 * @param ktsVisitedRecord 全部访问记录
 * @returns 全部访问记录
 */
function getVisitedRecordByUser(userKey: string, visitedItem: IVisitedItem, ktsVisitedRecord: IVisitedInfo[]) {
    let visitedByUser = null;
    let list = ktsVisitedRecord.filter(item => { // 不是当前用户数组
        if (item.userKey === userKey) {
            visitedByUser = item;
            return false;
        }
        return true;
    });
    if (visitedByUser) {
        return [...list, { userKey, visitedList: getVisitedList(visitedByUser.visitedList, visitedItem) }];
    }
    if (ktsVisitedRecord.length < 3) {
        ktsVisitedRecord.push({
            userKey,
            visitedList: getVisitedList([], visitedItem)
        });
    } else {
        ktsVisitedRecord.shift();
        ktsVisitedRecord.push({
            userKey,
            visitedList: getVisitedList([], visitedItem)
        });
    }
    return ktsVisitedRecord;

}

/**
 * 根据当前用户ID 在localStorage 中存放最近访问记录
 * @param userKey 用户cUserId
 * @param visited 最近访问记录数据
 */
export function setVisitedRecord(userKey: string, visited: IVisitedItem,callback:any) {
    const ktsVisitedRecord: any[] = getStorage('ktsVisitedRecord');
    if (ktsVisitedRecord === null || ktsVisitedRecord.length === 0) {
        setStorage('ktsVisitedRecord', [{ userKey, visitedList: getVisitedList([], visited) }],callback);
    } else {
        const data = getVisitedRecordByUser(userKey, visited, ktsVisitedRecord);
        setStorage('ktsVisitedRecord', data,callback);
    }


}

/**
 * 根据当前用户ID 返回当前用户的最近访问记录
 * @param userKey 用户ID
 * @returns  当前用户的最近访问记录
 */
export function getVisitedListByUserId(userKey: string) {
    const ktsVisitedRecord: any[] = getStorage('ktsVisitedRecord');
    if (ktsVisitedRecord) {
        let One=ktsVisitedRecord.findIndex(item => item.userKey === userKey);
        // tslint:disable-next-line:no-bitwise
        if(~One){
            return ktsVisitedRecord.find(item => item.userKey === userKey).visitedList;
        }else{
            return undefined;
        }
       
    } else {
        return undefined;
    }
}

export function setStorage(key: string, value: any,callback:any) {
    // console.log(value[0].visitedList);
    callback(value[0].visitedList);
    return window.parent.localStorage.setItem(key, JSON.stringify(value));
}

export function getStorage(key: string) {
    return JSON.parse( window.parent.localStorage.getItem(key));
}

export function deleteStorage(key: string) {
    window.parent.localStorage.removeItem(key);
}




// WEBPACK FOOTER //
// ./src/display/components/RecentlyVisited/storage.ts